/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState,useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import moment from 'moment';
// custom function import
import {
  validDate,
  focusToNextRowFirstCol,
} from '../../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  MinDate,
  dateFormat,
  dateFormatForDatePicker,
  receivedDateDays,
} from '../../../../../SharedModules/CommonConstants/commonConstants';
import { compareTwoDatesGreaterThanOrEqual } from '../../../../../SharedModules/DateUtilities/DateUtilities';
import { maintainLogCheckListData } from '../../store/Actions';
import SaveCancelPopup from '../../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';

export default ({gridApi, ...props}) => {
  const dispatch = useDispatch();
  const addNewRowLogCheckList = (data, action) => {
    return dispatch(maintainLogCheckListData(data, action));
  };
  const logCheckRowData = useSelector((state) => {
    return state.sharedState.CheckLogReducer.logCheckList;
  });
  const generalSystemParameterDetails = useSelector((state) => {
    return state.sharedState.CheckLogReducer.generalSystemParameter
      ?.paramGeneralVO;
  });

  const { colId } = props.column;
  const [open, setOpen] = useState(false);
  const typedInput = useRef()
  let rowIndex = 0;
  if (logCheckRowData && logCheckRowData.length > 0) {
    rowIndex = logCheckRowData.findIndex((x) => {
      return x.checkLogNum === props.data.checkLogNum;
    });
  }
  // handing on change date event
  const handleChangeDate = (d, event) => {
    if (d != 'Invalid Date') {
      const newObj = [...logCheckRowData];
      newObj[rowIndex].rowWithNewChange = true;
      let value = null;
      if (event === 'onBlur' && d.target.value && d.target.value.length > 5) {
        const data = d.target.value.split('/');
        if (data[2].split('_').length === 3) {
          value = moment(d.target.value, 'MM/DD/YY').format(dateFormat);
        } else {
          value =
            d.target.value && d.target.value != '' ? d.target.value : null;
        }
      } else {
        value = event === 'onBlur' ? d.target.value : d;
      }
      if (colId === 'receivedDt') {
        if (value === '' || value === null) {
          props.node.setDataValue(colId, value);
          newObj[rowIndex].receivedDt = value;
          newObj[rowIndex].receivedDateErr = true;
          addNewRowLogCheckList(newObj, 'verify');
        } else if (
          value !== null &&
          value !== '' &&
          validDate(new Date(value)) === false
        ) {
          props.node.setDataValue(colId, value);
          newObj[rowIndex].receivedDt = value;
          newObj[rowIndex].receivedDateErr = true;
          addNewRowLogCheckList(newObj, 'verify');
        } else if (
          value !== null &&
          value !== '' &&
          compareTwoDatesGreaterThanOrEqual(value, moment(MinDate))
        ) {
          props.node.setDataValue(colId, value);
          newObj[rowIndex].receivedDt = value;
          newObj[rowIndex].receivedDateErr = true;
          addNewRowLogCheckList(newObj, 'verify');
        } else if (
          compareTwoDatesGreaterThanOrEqual(new Date(), moment(value))
        ) {
          props.node.setDataValue(colId, value);
          newObj[rowIndex].receivedDt = value;
          newObj[rowIndex].receivedDateErr = true;
          addNewRowLogCheckList(newObj, 'verify');
        } else {
          props.node.setDataValue(colId, value);
          newObj[rowIndex].receivedDt = value;
          newObj[rowIndex].receivedDateErr = false;
          addNewRowLogCheckList(newObj, 'verify');
          const a = moment(value, dateFormat);
          const nowDate = moment(new Date(), dateFormat);
          if (
            nowDate.diff(a, 'days') > receivedDateDays &&
            !newObj[rowIndex].isYes &&typedInput.current
          ) {
            setOpen(true);
            newObj[rowIndex].receivedDatePopUp = true;
          }
        }
        newObj[rowIndex].checkPayeeCDActiveCursor = false;
        newObj[rowIndex].paymentMediaTypeCDActiveCursor = false;
        newObj[rowIndex].disputeResolutionCDActiveCursor = false;
        addNewRowLogCheckList(newObj, 'verify');
        props.handleOnblurEventReceivedDate();
      } else {
        if (
          value !== null &&
          value !== '' &&
          validDate(new Date(value)) === false
        ) {
          props.node.setDataValue(colId, value);
          newObj[rowIndex][colId] = value;
          newObj[rowIndex].isYes = false;
          if (colId === 'batchDt') newObj[rowIndex].batchDateErr = true;
          if (colId === 'checkDt') newObj[rowIndex].checkDateErr = true;
          if (colId === 'postmarkedDt')
            newObj[rowIndex].postMarkedDateErr = true;
          addNewRowLogCheckList(newObj, 'verify');
        } else if (
          value !== null &&
          value !== '' &&
          compareTwoDatesGreaterThanOrEqual(new Date(value), moment(MinDate))
        ) {
          props.node.setDataValue(colId, value);
          newObj[rowIndex][colId] = value;
          newObj[rowIndex].isYes = false;
          if (colId === 'batchDt') newObj[rowIndex].batchDateErr = true;
          if (colId === 'checkDt') newObj[rowIndex].checkDateErr = true;
          if (colId === 'postmarkedDt')
            newObj[rowIndex].postMarkedDateErr = true;
          addNewRowLogCheckList(newObj, 'verify');
        } else if (
          value !== null &&
          value !== '' &&
          compareTwoDatesGreaterThanOrEqual(new Date(), moment(value))
        ) {
          props.node.setDataValue(colId, value);
          newObj[rowIndex][colId] = value;
          newObj[rowIndex].isYes = false;
          if (colId === 'batchDt') newObj[rowIndex].batchDateErr = true;
          if (colId === 'checkDt') newObj[rowIndex].checkDateErr = true;
          if (colId === 'postmarkedDt')
            newObj[rowIndex].postMarkedDateErr = true;
          addNewRowLogCheckList(newObj, 'verify');
        } else {
          props.node.setDataValue(colId, value);
          newObj[rowIndex][colId] = value;
          newObj[rowIndex].isYes = false;
          if (colId === 'batchDt') newObj[rowIndex].batchDateErr = false;
          if (colId === 'checkDt') newObj[rowIndex].checkDateErr = false;
          if (colId === 'postmarkedDt')
            newObj[rowIndex].postMarkedDateErr = false;
          addNewRowLogCheckList(newObj, 'verify');
        }
        if (colId === 'batchDt') props.handleOnblurEventBatchDate();
        if (colId === 'checkDt') props.handleOnblurEventCheckDate();
        if (colId === 'postmarkedDt') props.handleOnblurEventPostMarkedDate();
      }
    }
    typedInput.current = false;
  };
  const handleAccept = (date)=>{
    if (date != 'Invalid Date') {
    const newObj = [...logCheckRowData];
    const a = moment(date, dateFormat);
    const nowDate = moment(new Date(), dateFormat);
    if (
      nowDate.diff(a, 'days') > receivedDateDays &&
      !newObj[rowIndex].isYes 
      
    ) {
      setOpen(true);
      newObj[rowIndex].receivedDatePopUp = true;
    }
  }
  }
  // handle Received Date confirm popup open
  const handleConfirm = () => {
    const tempObj = logCheckRowData.map((item) => {
      if (item.receivedDatePopUp) {
        item.receivedDatePopUp = false;
        item.checkAmtActiveCursor = false;
        item.isYes = true;
        props.node.setDataValue('receivedDt', item.receivedDt);
      }
      return item;
    });
    addNewRowLogCheckList(tempObj, 'verify');
    setOpen(false);
    if (props.gridParams) {
      let tableHead = [];
      tableHead =
        props.columnDefs &&
        props.columnDefs.filter((x) => {
          if (
            generalSystemParameterDetails &&
            generalSystemParameterDetails.length > 0 &&
            parseInt(generalSystemParameterDetails[0].checkLogUsesBatchInd) ===
              0
          ) {
            return x.field !== 'batchNum' && x.field !== 'batchDt';
          }
          return x;
        });
      focusToNextRowFirstCol(
        props.gridParams,
        tableHead &&
          tableHead.findIndex((x) => {
            return x.field === 'checkAmt';
          })
      );
    }
  };
  // handle cancel button click on popup
  const handleCancel = () => {
    const tempObj = logCheckRowData.map((item) => {
      if (item.receivedDatePopUp) {
        item.receivedDatePopUp = false;
        item.receivedDt = null;
        item.checkAmtActiveCursor = false;
        item.isYes = false;
        props.node.setDataValue('receivedDt', null);
      }
      return item;
    });
    addNewRowLogCheckList(tempObj, 'verify');
    setOpen(false);
  };
  
  return (
    <div data-testid="log-check-date-picker">
      <SaveCancelPopup
        open={open}
        title="Received Date"
        onConfim={() => {
          handleConfirm();
        }}
        onCancel={() => {
          handleCancel();
        }}
      />
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          required
          onAccept={handleAccept}
          id={`${colId}_${rowIndex}`}
          data-testid={
            colId === 'batchDt'
              ? 'batch-date'
              : colId === 'checkDt'
              ? 'check-date'
              : colId === 'postmarkedDt'
              ? 'post-mark-date'
              : 'received-date'
          }
          label={colId}
          className={
            colId === 'batchDt'
              ? logCheckRowData &&
                logCheckRowData[rowIndex] &&
                logCheckRowData[rowIndex].batchDateErr !== undefined &&
                logCheckRowData[rowIndex].batchDateErr
                ? 'td-active-cell tBill-validate frr-display-hidden-label'
                : 'frr-display-hidden-label'
              : colId === 'checkDt'
              ? logCheckRowData &&
                logCheckRowData[rowIndex] &&
                logCheckRowData[rowIndex].checkDateErr !== undefined &&
                logCheckRowData[rowIndex].checkDateErr
                ? 'td-active-cell tBill-validate frr-display-hidden-label'
                : 'frr-display-hidden-label'
              : colId === 'postmarkedDt'
              ? logCheckRowData &&
                logCheckRowData[rowIndex] &&
                logCheckRowData[rowIndex].postMarkedDateErr !== undefined &&
                logCheckRowData[rowIndex].postMarkedDateErr
                ? 'td-active-cell tBill-validate frr-display-hidden-label'
                : 'frr-display-hidden-label'
              : colId === 'receivedDt'
              ? logCheckRowData &&
                logCheckRowData[rowIndex] &&
                logCheckRowData[rowIndex].receivedDateErr !== undefined &&
                logCheckRowData[rowIndex].receivedDateErr
                ? 'td-active-cell tBill-validate frr-display-hidden-label'
                : 'frr-display-hidden-label'
              : 'frr-display-hidden-label'
          }
          format={dateFormatForDatePicker}
          inputFormat={dateFormatForDatePicker}
          mask="__/__/____"
          minDate={MinDate}
          maxDate={new Date()}
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            readOnly: false,
            autoFill: false,
            id: `${colId}_${rowIndex}`,
          }}
          placeholder="mm/dd/yyyy"
          value={
            props.value &&
              validDate(new Date(props.value))
              ? new Date(props.value)
              : null
          }
          onChange={(e) => {
            handleChangeDate(e, 'onChange');
          }}
          onBlur={(e) => {
            handleChangeDate(e, 'onBlur');
          }}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
          onKeyDown={async (e) => {
            if (e.keyCode == 67) {
              // copy date
              await window.navigator?.clipboard.writeText(e?.target?.value);
            }

            if (e.keyCode == 9) {
              if(gridApi) {
              if (e.shiftKey) {
                gridApi.tabToPreviousCell();
              } else {
               gridApi.tabToNextCell();
              }
              e.preventDefault();
              const tempObj = [...logCheckRowData];
              tempObj[rowIndex].checkPayeeCDActiveCursor = false;
              tempObj[rowIndex].paymentMediaTypeCDActiveCursor = false;
              tempObj[rowIndex].disputeResolutionCDActiveCursor = false;
              addNewRowLogCheckList(tempObj, 'verify');
            }
          }
          typedInput.current = true;
          }}
          helperText={null}
          error={null}
        />
      </MuiPickersUtilsProvider>
    </div>
  );
};
